import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';

const OrderAddresses = ({ orderAddresses, orderStatus }) => {
  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'space-between', width: '50%' }}
    >
      {orderAddresses?.map((address, index) => (
        <Box
          key={index}
          sx={[
            {
              display: 'flex',
              marginLeft: index === 0 ? 0 : 2,
            },
          ]}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Typography variant="span">
                  {address?.type === 'billing' ? 'Facturation' : 'Livraison'}
                </Typography>
              </Box>
              {address?.type === 'shipping' &&
                (orderStatus !== 'WAITING_SC' ||
                  orderStatus !== 'VALIDATED') && (
                  <Tooltip
                    title={
                      orderStatus !== 'WAITING_SC'
                        ? "Passez la commande en attente SC pour modifier l'adresse de livraison"
                        : "Modifier l'adresse de livraison dans la section Actions / Commande"
                    }
                  >
                    <Box>
                      <InfoOutlinedIcon
                        fontSize="0.8em"
                        sx={{ ml: 1, cursor: 'help' }}
                      />
                    </Box>
                  </Tooltip>
                )}
            </Box>
            {/* Informations d'adresse */}
            <Typography component={'span'} sx={{ fontSize: 12 }}>
              {address?.firstName} {address?.lastName}
            </Typography>
            <Typography component={'span'} sx={{ fontSize: 12 }}>
              {address?.phone}
            </Typography>
            <Typography component={'span'} sx={{ fontSize: 12 }}>
              {address?.line1}
            </Typography>
            <Typography component={'span'} sx={{ fontSize: 12 }}>
              {address?.line2}
            </Typography>
            <Typography component={'span'} sx={{ fontSize: 12 }}>
              {address?.postalCode}, {address?.city}
            </Typography>
            <Typography component={'span'} sx={{ fontSize: 12 }}>
              {address?.country}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default OrderAddresses;
